import { Suspense, useContext } from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import PagesRoutes from "routes/pages.routes";
import Header from "./Header";
import { SidebarContext } from "state/SideBarContext";

const loading = (
  <div className="loadingCon">
    <Spin
      indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
      size="large"
    />
  </div>
);

const Content = () => {
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
  return (
    <div className={sidebarToggle ? "whiteBoxWithToggle" : "whiteBoxWithoutToggle"}>
      <Suspense fallback={loading}>
        <div style={{ padding: "10px 0"}}>
          <Header />
          <PagesRoutes />
        </div>
      </Suspense>
    </div>
  );
};

export default Content;
